// extracted by mini-css-extract-plugin
export default {"root":"FormSelectAsync_root__Kx-Ek","fullWidth":"FormSelectAsync_fullWidth__RNiSQ"};